import { useState, useEffect } from 'react'

export function useMediaQuery(queryValue: string, initialValue = false) {
  const [match, setMatch] = useState(initialValue)

  useEffect(() => {
    let isMounted = true
    const matchMedia = window.matchMedia(queryValue)

    const handleChange = () => {
      if (!isMounted) return
      setMatch(Boolean(matchMedia.matches))
    }

    matchMedia.addEventListener('change', handleChange)
    setMatch(Boolean(matchMedia.matches))

    return () => {
      isMounted = false
      matchMedia.removeEventListener('change', handleChange)
    }
  }, [queryValue])

  return match
}

export const breakpoints = [
  { smartphone: '576px', tablet: '768px', laptop: '992px', pc: '1200px', largePc: '1400px' },
]
